import React, { useState, useEffect, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeUnits } from 'Core/hooks';
import moment from 'moment';

//Components
import { NotificationContainer, NotificationManager } from "Components/Notifications";
import {
    InputNumeric,
    FileUpload,
    SelectMenu,
    DatePicker,
    TextArea,
    Button,
    Select,
    Modal,
    Form,
    IconButton
} from "@gpstrackit/gtc-react-controls";
import { Chip } from 'Components'
import { Grid } from '@mui/material';

//Helpers
import { GetFormatForMoment } from '../../../../core/hooks/utils';
import { setContactId } from '../../../../core/hooks';
import {
    formatOffsetDisplayEngineHours,
    formatOffsetDisplayOdometer,
    getValueFloat,
    convertToMI,
    convertToKPH,
    OrderData
} from 'Core/data/Helpers';
import { getReadingEngineHours, roundEngineHours } from '../../.globals/helpers';

//Actions
import {
    maintenanceSMSCreateEditMaintenanceServiceUnit,
    maintenanceSMSSearchMaintenanceServices,
    maintenanceSMSgetMaintenanceServiceUnit,
    maintenanceSMSGetMaintenanceService,
    maintenanceSMSGetPreviousReading,
    maintenanceSMSSearchMaintenanceServiceItems,
    maintenanceSMSCreateMaintenanceServiceItem,
    reset,
} from './redux/slice';
import {
    openModalCreateEditMaintenanceService,
    uploadAttachment,
    catalogLoad,
} from 'Redux/actions';

//Styles
import './styles.scss';
const ScheduleMaintenanceService = (props) => {
    const { vehicle, refresh } = props;

    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = Form.useForm();

    const ALERT_TYPES = [
        { id: "Reminder", name: messages['reminder'] },
        { id: "DueNow", name: messages['dueNow'] },
        { id: "PastDue", name: messages['pastDue'] }
    ];

    //Redux States
    const {
        open,
        loading,
        result,
        maintenanceServiceUnitId,
        maintenanceServiceUnit,
        loadingPreviousReading,
        previousReading,
        updateScheduleMaintenanceServiceResponse,
        services,
        error,
        loadingMaintenanceServiceUnit,
        newServiceItemResult,
        serviceItems
    } = useSelector(state => state.maintenanceScheduleMaintenanceServiceRedux);

    const {
        updateMaintenanceServiceResult
    } = useSelector(state => state.maintenanceCreateEditMaintenanceServiceRedux);

    const maintenanceService = useSelector(state => state.maintenanceScheduleMaintenanceServiceRedux.service);
    const { performedServices } = useSelector(state => state.maintenancePerformedServicesRedux);
    const contactsReq = useSelector(state => state.catalogsRedux.contacts);
    const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);
    const loadingUnitsList = useSelector(state => state.catalogsRedux.loadingUnitsList);

    const { uploadedAttachment, loadingUploadFile } = useSelector(state => state.commomRedux);
    const onlyUnits = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
    const user = useSelector(state => state.securityRedux.user);


    //Local States
    const [contacts, setContacts] = useState([]);
    const [formData, setFormData] = useState({ intervalTypes: [], alerts: [], attachments: [] });
    const [reading, setReading] = useState(null);
    const [currentServices, setCurrentServices] = useState([]);
    const [dateTime, setDateTime] = useState("");
    const [vehicleType, setVehicleType] = useState(null);
    const [validateOdometer, setValidateOdometer] = useState(false);
    const [validateEngineHours, setValidateEngineHours] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorDate, setErrorDate] = useState(false);
    const [lastMaintenanceDate, setLastMaintenanceDate] = useState("");
    const [units, setUnits] = useState([]);
    const [serviceItemSelected, setServiceItemSelected] = useState([]);
    const [optionsSelect, setOptionsSelect] = useState([]);

    useEffect(() => {
        if (open && updateMaintenanceServiceResult) {
            setErrorMessage("");
            dispatch(maintenanceSMSGetMaintenanceService({ id: updateMaintenanceServiceResult.id }))
            setFormData({ ...formData, service: { id: updateMaintenanceServiceResult.id, title: updateMaintenanceServiceResult.title } });
            setTimeout(() => {
                formRef.setValues({ service: { id: updateMaintenanceServiceResult.id, title: updateMaintenanceServiceResult.title } })
            }, 100);
        }
    }, [updateMaintenanceServiceResult])

    useEffect(() => {
        if (serviceItems && Array.isArray(serviceItems)) {
            setOptionsSelect(OrderData(serviceItems, 'name'));
        }
    }, [serviceItems])

    useEffect(() => {
        if (maintenanceServiceUnit?.service) {
            setOptionsSelect(OrderData(serviceItems, 'name'));
        }

        if (maintenanceServiceUnit?.serviceUnitItems && maintenanceServiceUnit?.serviceUnitItems.length) {

            setServiceItemSelected(maintenanceServiceUnit?.serviceUnitItems)
            setTimeout(() => {
                let values = {}
                let newOptions = optionsSelect
                maintenanceServiceUnit?.serviceUnitItems.forEach((serv, index) => {
                    values[`parts-${index}`] = serv?.parts || '0'
                    values[`labor-${index}`] = serv?.labor || '0'
                    values[`subtotal-${index}`] = serv?.subtotal || '0'
                    newOptions = newOptions.filter((option) => option?.id != serv?.id);
                });
                newOptions && setOptionsSelect(OrderData(newOptions, 'name'));
                formRef.setValues(values)
                getTotalCost(maintenanceServiceUnit?.serviceUnitItems);
            }, 500);
        } else {
            setServiceItemSelected([])

        }
    }, [maintenanceServiceUnit?.id]);

    useEffect(() => {
        if (newServiceItemResult?.id) {
            addNewServiceItemToSelect(newServiceItemResult);
            onChangeSelectedItems(newServiceItemResult);
            dispatch(reset({ newServiceItemResult: null }))
        }
    }, [newServiceItemResult])

    const getOffset = (value) => (isNaN(value) ? 0 : getValueFloat(value));

    const getVehicleData = (vehicle, formData) => {
        const {
            useEcuOdometer = 0,
            useEcuEngineHours = 0,
            offsetEcuEngineHours,
            offsetEngineHours,
        } = vehicle || formData?.vehicle || {};

        const offset = useEcuEngineHours
            ? getOffset(offsetEcuEngineHours)
            : getOffset(offsetEngineHours);

        return { useEcuOdometer, useEcuEngineHours, offset };
    };

    // formData.engineOdometer / nextServiceOdometer are always stored in miles (API contract)
    const toDisplayOdometer = (miles) => {
        if (miles === "" || miles == null || miles === undefined) return "";
        const n = Number(miles);
        if (!Number.isFinite(n)) return "";
        return user.isKph ? convertToKPH(n) : Math.round(n);
    };

    const isPastServiceDate = (date) => {
        if (!date) return false;
        return moment(date).startOf('day').isBefore(moment().startOf('day'));
    };

    const getLiveVehicleOdometerMiles = (vehicleData) => {
        if (!vehicleData) return "";
        const fromDisplay = vehicleData.displayOdometer;
        if (fromDisplay !== "" && fromDisplay != null && fromDisplay !== undefined) {
            const displayNum = Number(fromDisplay);
            if (Number.isFinite(displayNum)) return Math.round(displayNum);
        }
        const raw = formatOffsetDisplayOdometer(vehicleData);
        if (raw === "" || raw == null) return "";
        const n = Number(raw);
        return Number.isFinite(n) ? Math.round(n) : "";
    };

    const applyLiveVehicleReadings = (currentVehicle) => {
        const odometerMiles = getLiveVehicleOdometerMiles(currentVehicle);
        const engineHoursVal = roundEngineHours(formatOffsetDisplayEngineHours(currentVehicle)) || 0;
        if (odometerMiles === "" && !engineHoursVal) return;

        const payload = {};
        if (odometerMiles !== "") payload.engineOdometer = odometerMiles;
        if (engineHoursVal) payload.engineHours = engineHoursVal;
        setData(payload);

        const formValues = {};
        if (odometerMiles !== "") formValues.engineOdometer = toDisplayOdometer(odometerMiles);
        if (engineHoursVal) formValues.engineHours = engineHoursVal;
        setTimeout(() => formRef.setValues(formValues), 200);
    };

    const buildUnitTimeRange = (date) => {
        const end = moment(date).endOf('day');
        return {
            start: end.clone().subtract(90, 'days').startOf('day').unix(),
            end: end.unix(),
        };
    };

    const getHistoricalOdometerMiles = (currentVehicle, reading) => {
        if (!reading || !currentVehicle) return "";
        const { useEcuOdometer } = getVehicleData(currentVehicle, formData);
        const offset = parseFloat(useEcuOdometer ? currentVehicle?.offsetEcuEngineOdometer : currentVehicle?.offsetEngineOdometer || 0);
        const raw = useEcuOdometer
            ? (reading?.ecuEngineOdometer ?? reading?.engineOdometer)
            : (reading?.engineOdometer ?? reading?.ecuEngineOdometer);
        const total = parseFloat(raw) + offset;
        return isNaN(total) ? "" : Math.round(total);
    };

    const getHistoricalEngineHours = (currentVehicle, reading) => {
        if (!reading || !currentVehicle) return "";
        const { useEcuEngineHours, offset } = getVehicleData(currentVehicle, formData);
        const readingHours = getReadingEngineHours(reading, useEcuEngineHours);
        if (readingHours === null) return "";
        return roundEngineHours(readingHours + offset);
    };

    useEffect(() => {
        if (!open || maintenanceServiceUnitId) return;

        const currentVehicle = vehicle || formData?.vehicle;
        if (!currentVehicle || !formData?.date) return;

        if (previousReading?.length) {
            const historicalReading = previousReading[0];
            if (!historicalReading) return;

            const engineOdometer = getHistoricalOdometerMiles(currentVehicle, historicalReading);
            const engineHours = getHistoricalEngineHours(currentVehicle, historicalReading);

            setReading(historicalReading);
            const payload = { date: formData.date, engineOdometer, engineHours: roundEngineHours(engineHours) || "" };
            if (formData?.service) payload.service = formData.service;
            setData(payload);
            setErrorMessage("");
        } else if (!loadingPreviousReading && previousReading != null && isPastServiceDate(formData.date)) {
            setErrorMessage(messages['scheduleMaintenanceService_historicalOdometerRequired']);
        } else if (!loadingPreviousReading && previousReading != null && !isPastServiceDate(formData.date)) {
            const liveOdometer = getLiveVehicleOdometerMiles(currentVehicle);
            const liveHours = roundEngineHours(formatOffsetDisplayEngineHours(currentVehicle)) || 0;
            setReading({ engineOdometer: liveOdometer, engineHours: liveHours });
            const payload = {
                date: formData.date,
                engineOdometer: liveOdometer,
                engineHours: liveHours,
            };
            if (formData?.service) {
                payload.service = formData.service;
            }
            setData(payload);
        }
    }, [previousReading, open, maintenanceServiceUnitId, loadingPreviousReading, formData?.service, formData?.date])

    useEffect(() => {
        if (error) {
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }))
        }
    }, [error])

    useEffect(() => {
        if (open && maintenanceService) {
            if (!maintenanceServiceUnitId && !maintenanceServiceUnit?.id && maintenanceService?.serviceItems && maintenanceService.serviceItems.length) {
                setServiceItemSelected(maintenanceService.serviceItems)
                setTimeout(() => {
                    let values = {}
                    let newOptions = optionsSelect
                    maintenanceService.serviceItems.forEach((serv, index) => {
                        values[`parts-${index}`] = serv?.parts || '0'
                        values[`labor-${index}`] = serv?.labor || '0'
                        values[`subtotal-${index}`] = serv?.subtotal || '0'
                        newOptions = newOptions.filter((option) => option?.id != serv?.id);
                    });
                    newOptions && setOptionsSelect(OrderData(newOptions, 'name'));
                    formRef.setValues(values)
                    getTotalCost(maintenanceService.serviceItems);
                }, 500);
            }

            if (maintenanceService?.id && !currentServices?.find(s => s?.id == maintenanceService?.id)) {
                setCurrentServices([maintenanceService, ...currentServices]);
            }

            setData({
                service: maintenanceService,
                lastMaintenanceDate: maintenanceServiceUnit?.lastMaintenanceDate || formData.date,
                ...(maintenanceServiceUnit ? {
                    engineOdometer: maintenanceServiceUnit.lastMaintenanceOdometer,
                    engineHours: maintenanceServiceUnit.lastMaintenanceEngineHours,
                    nextServiceOdometer: maintenanceServiceUnit.nextServiceOdometer,
                    nextServiceEngineHours: maintenanceServiceUnit.nextServiceEngineHours,
                    nextServiceDate: maintenanceServiceUnit.nextServiceDate,
                } : {}),
            });
        }
    }, [open, maintenanceService]);

    useEffect(() => {
        if (result) {
            dispatch(reset({ result: null }))
        }
    }, [result]);

    useEffect(() => {
        if (open && props.service) {
            dispatch(maintenanceSMSGetMaintenanceService({ id: props.service.id }))
        }
    }, [open, props.service]);

    useEffect(() => {
        if (maintenanceServiceUnitId) {
            dispatch(reset({ previousReading: null }));
            dispatch(maintenanceSMSgetMaintenanceServiceUnit({ id: maintenanceServiceUnitId }))
        }
    }, [maintenanceServiceUnitId])

    useEffect(() => {
        dispatch(catalogLoad(["contacts"]));
    }, []);

    useEffect(() => {
        if (contactsReq && contactsReq.length) {
            const newContacts = setContactId(contactsReq);
            setContacts(OrderData(newContacts, 'title'));
        }
    }, [contactsReq]);

    useEffect(() => {
        if (open) {
            const loadCatalog = ['onlyUnits'];
            if (contacts?.length == 0) {
                loadCatalog.push('contacts');
            }
            dispatch(catalogLoad(loadCatalog));
        }
    }, [open])

    useEffect(() => {
        if (onlyUnits && onlyUnits.length) {
            setUnits(OrderData(onlyUnits, 'Label'));
            if (maintenanceServiceUnit) {
                setData({ unitId: maintenanceServiceUnit.unitId });
            }
        }
    }, [onlyUnits, maintenanceServiceUnit]);

    useEffect(() => {
        if (!open || maintenanceServiceUnitId || formData?.date) return;
        const currentVehicle = vehicle || formData?.vehicle;
        if (!currentVehicle) return;
        applyLiveVehicleReadings(currentVehicle);
    }, [open, vehicle, formData?.vehicle, formData?.date, maintenanceServiceUnitId]);

    useEffect(() => {
        if (services && services.length) {
            if (maintenanceServiceUnit) {
                dispatch(maintenanceSMSGetMaintenanceService({ id: maintenanceServiceUnit.service.id }))
                setLastMaintenanceDate(maintenanceServiceUnit?.lastMaintenanceDate || "")
                setDateTime(moment(maintenanceServiceUnit.lastMaintenanceDate).utc().format());
            }
            if (!props.service) {
                let servicesList = [
                    ...OrderData(services || [], 'title'),
                ];
                setCurrentServices(servicesList);
            }
        }
    }, [services, maintenanceServiceUnit]);

    useEffect(() => {
        if (open) {
            dispatch(maintenanceSMSSearchMaintenanceServices({}))
            dispatch(maintenanceSMSSearchMaintenanceServiceItems({}))
        }
    }, [open]);

    useEffect(() => {
        if (formData.intervalTypes) {
            let validateMiles = formData.intervalTypes.some((item) => item.intervalType === "Miles");
            let validateEngineHours = formData.intervalTypes.some((item) => item.intervalType === "Engine Hours");
            setValidateOdometer(validateMiles)
            setValidateEngineHours(validateEngineHours)
        }
    }, [formData.intervalTypes])

    const handleSuccess = () => {
        let message = messages['scheduleVehicleService_success']
        if (maintenanceServiceUnit) {
            message = messages['ScheduleService_saved']
        }
        NotificationManager.success(
            messages['success'],
            message,
            3000,
            null,
            null,
            'success'
        );
        if (refresh) refresh();
        handleClose();
    }

    const handleClose = () => {
        dispatch(reset());
        formRef?.resetValues();
        setFormData({ intervalTypes: [], alerts: [], attachments: [] })
    };

    const calculateNextServiceDate = useCallback((service, date) => {
        let next = "";
        if (date) {
            let newDate = moment(date)
            newDate = newDate.add(service.days, 'days')
            next = newDate.format();
        }
        return {
            intervalType: messages['days'],
            interval: service.days,
            reminder: service.daysBefore,
            pastDue: service.daysAfter,
            next: next
        }
    }, [messages]);

    const calculateNextOdometer = (service, odometer) => {
        let next = Math.floor((service.miles || 0) + (odometer ? parseFloat(odometer) : 0));
        return {
            intervalType: messages['miles'],
            interval: service.miles,
            reminder: service.milesBefore,
            pastDue: service.milesAfter,
            next: next
        };
    };

    const calculateNextEngineHours = (service, engineHours) => {
        let next = roundEngineHours((Number(service.engineHours) || 0) + (roundEngineHours(engineHours) || 0));
        return {
            intervalType: messages['engineHours'],
            interval: service.engineHours,
            reminder: service.engineHoursBefore,
            pastDue: service.engineHoursAfter,
            next: next
        };
    };

    const setData = (data) => {
        let newFormData = {};
        let baseSubscribers = [];
        let baseAttachments = [];
        let completed = [];

        if (data.date) {
            newFormData.date = data.date;
        }

        if (data.unitId) {
            newFormData.vehicle = onlyUnits.find((unit) => unit.id && unit.id.toString() === data.unitId.toString());
        }

        if (data.lastMaintenanceDate && data.lastMaintenanceDate != "0000-00-00 00:00:00") {
            data.date = moment(data.lastMaintenanceDate).toDate();
            newFormData.date = moment(data.lastMaintenanceDate).toDate();
            setDateTime(moment(data.lastMaintenanceDate).toDate());
        }

        if (data.engineOdometer != null && data.engineOdometer != undefined) {
            newFormData.engineOdometer = data.engineOdometer;
        }

        if (data.engineHours != null && data.engineHours != undefined) {
            newFormData.engineHours = data.engineHours;
        }

        if (data.lastMaintenanceOdometer != null && data.lastMaintenanceOdometer != undefined) {
            newFormData.engineOdometer = data.lastMaintenanceOdometer;
        }

        if (data.lastMaintenanceEngineHours != null && data.lastMaintenanceEngineHours != undefined) {
            newFormData.engineHours = data.lastMaintenanceEngineHours;
        }

        if (data.notes) {
            newFormData.notes = data.notes;
        }

        const activeService = newFormData.service ?? formData.service;
        const odometerBase = newFormData.engineOdometer ?? formData.engineOdometer;
        const hasStoredNext = maintenanceServiceUnitId && data.nextServiceOdometer != null && data.nextServiceOdometer !== "";
        if (!data.service && activeService?.miles && odometerBase != null && odometerBase !== "" && !hasStoredNext) {
            const nextMiles = calculateNextOdometer(activeService, odometerBase);
            newFormData.nextServiceOdometer = nextMiles.next;
            newFormData.intervalTypes = [
                ...(formData.intervalTypes || []).filter((item) => item.intervalType !== messages['miles']),
                nextMiles,
            ];
        }

        if (data.service) {
            newFormData.intervalTypes = [];
            newFormData.nextServiceDate = "";
            newFormData.nextServiceOdometer = "";
            if (Number(data.service.engineHours) > 0) {
                newFormData.nextServiceEngineHours = "";
            } else {
                newFormData.nextServiceEngineHours = null;
            }

            if (data.service.days) {
                const serviceDate = newFormData.date || data.date;
                if (serviceDate) {
                    let nextDay;
                    if (data.nextServiceDate && data.nextServiceDate !== "") {
                        newFormData.nextServiceDate = data.nextServiceDate;
                        nextDay = {
                            intervalType: messages['days'],
                            interval: data.service.days,
                            reminder: data.service.daysBefore,
                            pastDue: data.service.daysAfter,
                            next: data.nextServiceDate,
                        };
                    } else {
                        const date = moment(serviceDate).format('YYYY-MM-DD HH:mm A');
                        const checkingTime = moment(date.replace(" PM", "").replace(" AM", ""));
                        nextDay = calculateNextServiceDate(data.service, checkingTime);
                        newFormData.nextServiceDate = nextDay.next;
                    }
                    newFormData.date = serviceDate;
                    newFormData.intervalTypes.push(nextDay);
                }

            }
            if (data.service.miles) {
                if (hasStoredNext) {
                    newFormData.nextServiceOdometer = data.nextServiceOdometer;
                    newFormData.intervalTypes.push({
                        intervalType: messages['miles'],
                        interval: data.service.miles,
                        reminder: data.service.milesBefore,
                        pastDue: data.service.milesAfter,
                        next: data.nextServiceOdometer,
                    });
                } else {
                    const nextMiles = calculateNextOdometer(data.service, newFormData.engineOdometer ?? formData.engineOdometer);
                    newFormData.nextServiceOdometer = nextMiles.next;
                    newFormData.intervalTypes.push(nextMiles);
                }
            }

            if (Number(data.service.engineHours) > 0) {
                const hoursBase = newFormData.engineHours ?? formData.engineHours;
                const hasStoredNextHours = maintenanceServiceUnitId
                    && data.nextServiceEngineHours != null
                    && data.nextServiceEngineHours !== "";
                let nextHours;
                if (hasStoredNextHours) {
                    newFormData.nextServiceEngineHours = data.nextServiceEngineHours;
                    nextHours = {
                        intervalType: messages['engineHours'],
                        interval: data.service.engineHours,
                        reminder: data.service.engineHoursBefore,
                        pastDue: data.service.engineHoursAfter,
                        next: data.nextServiceEngineHours,
                    };
                } else if (hoursBase != null && hoursBase !== "") {
                    nextHours = calculateNextEngineHours(data.service, hoursBase);
                    newFormData.nextServiceEngineHours = nextHours.next;
                }
                if (nextHours) {
                    newFormData.intervalTypes.push(nextHours);
                }
            }

            if (!maintenanceServiceUnitId && data.service.subscribers) {
                baseSubscribers = data.service.subscribers;
            }

            newFormData.service = data.service;
        }

        if (maintenanceServiceUnitId && maintenanceServiceUnit && maintenanceServiceUnit.subscribers) {
            baseSubscribers = maintenanceServiceUnit.subscribers;
        }

        if (data.subscribers) {
            baseSubscribers = data.subscribers;
        }

        newFormData.alerts = baseSubscribers.map(subscriber => {
            let options = [];

            if (subscriber.alert) {
                options.push({ id: "Reminder", name: messages['reminder'] });
            }

            if (subscriber.alertBefore) {
                options.push({ id: "DueNow", name: messages['dueNow'] });
            }

            if (subscriber.alertAfter) {
                options.push({ id: "PastDue", name: messages['pastDue'] });
            }

            return {
                id: subscriber?.id,
                contactId: subscriber?.contact?.id || subscriber?.contactId,
                title: contacts?.filter(c => c?.id == subscriber?.contactId)?.map(c => c?.title),
                options: options
            }
        });

        if (maintenanceServiceUnitId && maintenanceServiceUnit && maintenanceServiceUnit.completed && performedServices) {
            completed = performedServices.find((service) => {
                return service.serviceUnitId === maintenanceServiceUnitId;
            });
            newFormData.completed = moment(completed?.maintenanceDate).toDate();
        }

        if (maintenanceServiceUnitId && maintenanceServiceUnit && maintenanceServiceUnit.files) {
            baseAttachments = maintenanceServiceUnit.files;
        }

        if (data.attachments) {
            baseAttachments = data.attachments;
        }

        newFormData.attachments = [...baseAttachments];
        setFormData((prev) => {
            const next = { ...prev, ...newFormData };
            setTimeout(() => {
                const displayValues = { ...prev, ...newFormData };
                if (displayValues.engineOdometer != null && displayValues.engineOdometer !== "") {
                    displayValues.engineOdometer = toDisplayOdometer(displayValues.engineOdometer);
                }
                formRef.setValues(displayValues);
            }, 100);
            return next;
        });
    };

    const getReadings = (deviceId, date) => {
        if (!deviceId || !date) return;
        dispatch(reset({ previousReading: null }));
        dispatch(maintenanceSMSGetPreviousReading({
            deviceId: `${deviceId}`,
            unitTime: buildUnitTimeRange(date),
        }));
        setDateTime(moment(date).utc().format());
    }

    const isDateInputDisabled = () => {
        if (loadingPreviousReading) {
            return true;
        }

        if (!vehicle && !props.service) {
            return true;
        }

        if (props.service && !formData.vehicle) {
            return true;
        }

        if (vehicle && !formData.service) {
            return true;
        }

        return false;
    }

    // Date or odometer changed: the odometer baseline (and a past date's historical reading) must be resolved again
    const hasDateOrOdometerChanged = () => {
        if (!maintenanceServiceUnit) return true;

        const storedDate = maintenanceServiceUnit.lastMaintenanceDate;
        if (storedDate && formData.date) {
            if (!moment(storedDate).startOf('day').isSame(moment(formData.date).startOf('day'))) {
                return true;
            }
        } else if (formData.date && !storedDate) {
            return true;
        }

        const storedOdometer = maintenanceServiceUnit.lastMaintenanceOdometer;
        const currentOdometer = formData.engineOdometer;
        if (storedOdometer != null && storedOdometer !== undefined && currentOdometer != null && currentOdometer !== "") {
            if (parseFloat(storedOdometer) !== parseFloat(currentOdometer)) return true;
        }

        return false;
    };

    const hasEngineHoursChanged = () => {
        if (!maintenanceServiceUnit) return true;

        const storedEngineHours = maintenanceServiceUnit.lastMaintenanceEngineHours;
        const currentEngineHours = formData.engineHours;
        if (currentEngineHours != null && currentEngineHours !== "") {
            return storedEngineHours == null || parseFloat(storedEngineHours) !== parseFloat(currentEngineHours);
        }

        return false;
    };

    const hasScheduleBaselineChanged = () => hasDateOrOdometerChanged() || hasEngineHoursChanged();

    const resolveOdometerForSubmit = async (currentVehicle, deviceId) => {
        if (maintenanceServiceUnit && !hasDateOrOdometerChanged()) {
            // Keep the stored odometer baseline; only take the engine hours when the user changed them
            let engineHours = maintenanceServiceUnit.lastMaintenanceEngineHours;
            if (hasEngineHoursChanged()) {
                engineHours = formData.engineHours;
            }
            return {
                lastOdometerMiles: maintenanceServiceUnit.lastMaintenanceOdometer,
                engineHours,
                historicalReading: reading,
            };
        }

        if (!isPastServiceDate(formData.date)) {
            return {
                lastOdometerMiles: formData.engineOdometer,
                engineHours: formData.engineHours,
                historicalReading: reading,
            };
        }

        let historicalReading = previousReading?.[0] || null;
        if (!historicalReading && deviceId) {
            try {
                const readings = await dispatch(maintenanceSMSGetPreviousReading({
                    deviceId: `${deviceId}`,
                    unitTime: buildUnitTimeRange(formData.date),
                })).unwrap();
                historicalReading = Array.isArray(readings) ? readings[0] : null;
            } catch {
                historicalReading = null;
            }
        }

        if (historicalReading) {
            const lastOdometerMiles = getHistoricalOdometerMiles(currentVehicle, historicalReading);
            if (lastOdometerMiles !== "") {
                setReading(historicalReading);
                // The value the user entered (or kept from the prefill) wins over the reading
                let engineHours = formData.engineHours;
                if (engineHours == null || engineHours === "") {
                    engineHours = getHistoricalEngineHours(currentVehicle, historicalReading);
                }
                return {
                    lastOdometerMiles,
                    engineHours,
                    historicalReading,
                };
            }
        }

        if (formData.engineOdometer != null && formData.engineOdometer !== "") {
            return {
                lastOdometerMiles: formData.engineOdometer,
                engineHours: formData.engineHours,
                historicalReading: historicalReading,
            };
        }

        return null;
    };

    useEffect(() => {
        if (updateScheduleMaintenanceServiceResponse && updateScheduleMaintenanceServiceResponse) {
            handleSuccess();
        }
    }, [updateScheduleMaintenanceServiceResponse]);

    const handleSubmit = async () => {
        setErrorMessage("");
        setErrorDate(false)
        let unitId = "";
        let serviceId = "";
        let deviceId = "";

        if (!formData?.date) {
            setErrorDate(true)
            return;
        }

        if (isPastServiceDate(formData.date) && loadingPreviousReading) {
            setErrorMessage(messages['scheduleMaintenanceService_historicalOdometerRequired']);
            return;
        }

        const currentVehicle = vehicle || formData?.vehicle;
        if (vehicle) {
            unitId = vehicle.id;
            serviceId = parseInt(formData.service.id);
        } else if (props.service) {
            unitId = formData.vehicle.id;
            serviceId = props.service.id;
        }
        deviceId = currentVehicle?.deviceId || currentVehicle?.id || "";

        let dateNextServiceDate = null;

        if (formData.nextServiceDate) {
            const newDateNextService = moment(formData.nextServiceDate);
            dateNextServiceDate = newDateNextService.utc().format();
        }

        const odometerResolution = await resolveOdometerForSubmit(currentVehicle, deviceId);

        if (!odometerResolution) {
            setErrorMessage(messages['scheduleMaintenanceService_historicalOdometerRequired']);
            return;
        }

        const { lastOdometerMiles, engineHours: resolvedEngineHours, historicalReading } = odometerResolution;

        let nextOdometerMiles = formData.nextServiceOdometer ?? null;
        // An engine hours-only edit keeps the stored odometer baseline, so keep its next service odometer too
        if (maintenanceServiceUnit && !hasDateOrOdometerChanged()) {
            nextOdometerMiles = maintenanceServiceUnit.nextServiceOdometer ?? nextOdometerMiles;
        } else if (formData?.service?.miles && lastOdometerMiles != null && lastOdometerMiles !== "") {
            nextOdometerMiles = calculateNextOdometer(formData.service, lastOdometerMiles).next;
        }

        if (formData?.service?.miles && lastOdometerMiles != null && nextOdometerMiles != null
            && parseFloat(nextOdometerMiles) <= parseFloat(lastOdometerMiles)) {
            setErrorMessage(messages['errorMessage']);
            return;
        }

        let nextEngineHours = null;
        if (Number(formData?.service?.engineHours) > 0) {
            if (maintenanceServiceUnit && !hasScheduleBaselineChanged()) {
                nextEngineHours = maintenanceServiceUnit.nextServiceEngineHours ?? formData.nextServiceEngineHours;
            } else if (resolvedEngineHours != null && resolvedEngineHours !== "") {
                nextEngineHours = calculateNextEngineHours(formData.service, resolvedEngineHours).next;
            } else {
                nextEngineHours = formData.nextServiceEngineHours;
            }
            nextEngineHours = nextEngineHours != null && nextEngineHours !== "" ? Number(nextEngineHours) : null;
            if (!Number.isFinite(nextEngineHours)) {
                nextEngineHours = null;
            }
        }

        const lastReadingId = historicalReading?.unitId
            ? `${historicalReading.unitId}_${historicalReading.unitTime}`
            : (maintenanceServiceUnit?.lastReadingId || null);

        let data = {
            lastReadingId,
            lastMaintenanceDate: dateTime,
            lastMaintenanceEngineHours: roundEngineHours(resolvedEngineHours),
            lastMaintenanceOdometer: lastOdometerMiles ?? null,
            nextServiceDate: dateNextServiceDate,
            nextServiceOdometer: nextOdometerMiles != null && nextOdometerMiles !== "" ? Number(nextOdometerMiles) : null,
            nextServiceEngineHours: nextEngineHours,
            notes: formData.notes,
            estimatedCost: formData?.service?.estimatedCost,
            fileIds: []
        };

        if (maintenanceServiceUnit) {
            data.id = maintenanceServiceUnit.id;
        } else {
            data.serviceId = serviceId;
            data.unitId = unitId;
        }

        if (formData.attachments && formData.attachments.length) {
            data.fileIds = formData.attachments.map(attachment => {
                if (attachment?.id || attachment?.Id) {
                    return attachment.id || attachment.Id;
                }
            })
        }

        if (formData.completed) {
            data.maintenanceCompleted = formData.completed
        }


        let alertsForUpdate = [];

        alertsForUpdate = formData.alerts.map(alert => {
            let alrt = alert.options.find(alertType => alertType.name === messages['reminder']);
            let alertBefore = alert.options.find(alertType => alertType.name === messages['dueNow']);
            let alertAfter = alert.options.find(alertType => alertType.name === messages['pastDue']);

            return {
                contactId: alert.contactId || alert.contactId,
                alert: alrt ? 1 : 0,
                alertBefore: alertBefore ? 1 : 0,
                alertAfter: alertAfter ? 1 : 0
            }
        });

        data.subscribers = alertsForUpdate || []

        let itemsResult = []
        if (serviceItemSelected.length > 0) {
            serviceItemSelected.map((item) => {
                const { __typename, ...resultItem } = item;
                itemsResult.push({
                    id: resultItem?.id,
                    parts: resultItem?.parts || 0,
                    labor: resultItem?.labor || 0,
                    subtotal: resultItem?.subtotal || 0,
                    name: resultItem?.name
                })
            })
            data.items = itemsResult;
        }

        if (!currentVehicle?.odometerEnable && formData?.service?.miles) {
            setErrorMessage(messages['scheduleMaintenanceService_notSupportOdometer']);
        } else if (!currentVehicle?.hoursEnable && formData?.service?.engineHours) {
            setErrorMessage(messages['scheduleMaintenanceService_notSupportEngine']);
        } else {
            if (moment(lastMaintenanceDate).unix() === moment(data?.lastMaintenanceDate).unix()) {
                delete data['lastMaintenanceDate']
            }
            dispatch(maintenanceSMSCreateEditMaintenanceServiceUnit(data))
        }
    }

    const addNewServiceItemToSelect = (serviceItem) => {
        let newServiceItems = JSON.parse(JSON.stringify(serviceItems))
        newServiceItems = [serviceItem, ...newServiceItems];
        setOptionsSelect(OrderData(newServiceItems, 'name'));
    }

    const renderItem = (item, key) => {

        let name = item?.name || ""
        if (name.length > 8) {
            name = name.slice(0, 8) + '...';
        }

        return (
            <Grid container item sm={12} key={key} spacing={0} alignItems="center">
                <Grid item sm={2} style={{ height: 80 }}>
                    <Grid container direction="column" alignItems="flex-start" justifyContent="center" className="contentLabelItems overflow-break-word">
                        <Grid item container sm={12}>
                            <Grid item sm={12}>
                                <label style={{
                                    color: '#000',
                                    fontSize: 12,
                                    fontWeight: 'bold',
                                    lineHeight: 1.5,
                                    letterSpacing: '.00938em',
                                    alignSelf: 'unset',
                                }}>
                                    {messages['completeMaintenanceService_item']}
                                </label>
                            </Grid>
                        </Grid>
                        <Grid item container className="labelContainer" alignItems="center" justifyContent="center" style={{ marginBottom: 4 }}>
                            <Grid item sm={12}>
                                <label className="labelItemService" style={{ wordWrap: 'break-word' }}>{name}</label>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container justifyContent="flex-end" alignItems="center" sm={10}>
                    <Grid item container sm={11} spacing={1}>
                        <Grid item sm={4}>
                            <Form.Item
                                name={`parts-${key}`}
                                label={messages['completeMaintenanceService_parts']}
                                rules={[
                                    {
                                        min: 0,
                                        message: `${messages['min']}: 0`
                                    },
                                    {
                                        max: 999999,
                                        message: `${messages['max']}: 999999`
                                    }
                                ]}
                            >
                                <InputNumeric
                                    id={`parts-${key}`}
                                    type="currency"
                                    onChange={(value) => {
                                        onChangeItem(key, 'parts', value);
                                        setTimeout(() => {
                                            let currentValues = parseFloat(value || 0) + parseFloat(item.labor || 0)
                                            formRef.setValues({
                                                [`subtotal-${key}`]: currentValues
                                            })
                                        }, 200);
                                    }}
                                    placeholder={'$'}
                                    maxLength={9}
                                    decimalPlaces={2}
                                />
                            </Form.Item>
                        </Grid>
                        <Grid item sm={4}>
                            <Form.Item
                                name={`labor-${key}`}
                                label={messages['completeMaintenanceService_labor']}
                                rules={[
                                    {
                                        min: 0,
                                        message: `${messages['min']}: 0`
                                    },
                                    {
                                        max: 999999,
                                        message: `${messages['max']}: 999999`
                                    }
                                ]}
                            >
                                <InputNumeric
                                    id={`labor-${key}`}
                                    type="currency"
                                    onChange={(value) => {
                                        onChangeItem(key, 'labor', value);
                                        setTimeout(() => {
                                            let currentValues = parseFloat(item.parts || 0) + parseFloat(value || 0)
                                            formRef.setValues({
                                                [`subtotal-${key}`]: currentValues
                                            })
                                        }, 200);
                                    }}
                                    placeholder={'$'}
                                    maxLength={9}
                                    decimalPlaces={2}
                                />
                            </Form.Item>
                        </Grid>
                        <Grid item sm={4}>
                            <Form.Item
                                name={`subtotal-${key}`}
                                label="SUBTOTAL"
                            >
                                <InputNumeric
                                    id={`subtotal-${key}`}
                                    type="currency"
                                    onChange={(value) => {
                                        onChangeItem(key, 'labor', value);
                                    }}
                                    placeholder={'$'}
                                    isDisabled
                                />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Grid item container justifyContent="flex-end" sm={1}>
                        <Grid item sm={3}></Grid>
                        <Grid item sm={9}>
                            <div className="form-item">
                                <label className="input-normal-label"></label>
                                <IconButton
                                    aria-label="placeholder"
                                    className="icon-trash-item"
                                    onClick={() => onDelete(item.id)}
                                    icon="delete"
                                    style={{ padding: 5, fontSize: 20 }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const onDelete = (id) => {
        let newServiceItems = JSON.parse(JSON.stringify(serviceItemSelected));
        let newOptionsSelect = JSON.parse(JSON.stringify(optionsSelect));
        const oldOptionSelected = newServiceItems.find((service) => service.id == id);
        newServiceItems = newServiceItems.filter((service) => service.id != id);
        newOptionsSelect.push(oldOptionSelected);
        setOptionsSelect(OrderData(newOptionsSelect, 'name'));
        setServiceItemSelected(newServiceItems);

        newServiceItems.forEach((item, index) => {
            setTimeout(() => {
                formRef.setValues({
                    [`parts-${index}`]: item?.parts,
                    [`labor-${index}`]: item?.labor,
                    [`subtotal-${index}`]: item?.subtotal,
                })
            }, 200);
        });

        getTotalCost(newServiceItems);
    };


    const onChangeItem = (key, name, value) => {
        let newServiceItems = JSON.parse(JSON.stringify(serviceItemSelected));
        let newValue = value;
        if (newValue < 0) {
            newValue = 0;
        }
        if (newServiceItems[key]) {
            let temp = newServiceItems[key];
            temp[name] = +newValue === 0 ? newValue : parseFloat(newValue)
            temp['subtotal'] = parseFloat(temp.parts || 0) + parseFloat(temp.labor || 0);
            newServiceItems[key] = temp;
            setServiceItemSelected(newServiceItems);
            getTotalCost(newServiceItems);
        }
    };

    const reducer = (accumulator, currentValue) => accumulator + currentValue.subtotal;


    const getTotalCost = (newServiceItem) => {
        if (newServiceItem.length) {
            const total = newServiceItem.reduce(reducer, 0);
            setTimeout(() => {
                formRef?.setValues({ totalCost: total })
            }, 100);
        } else {
            setTimeout(() => {
                formRef?.setValues({ totalCost: 0 })
            }, 100);
        }
    };

    const addNewOption = (name) => {
        if (name) {
            dispatch(maintenanceSMSCreateMaintenanceServiceItem({ name }))
        }
    };

    const onChangeSelectedItems = (value) => {
        setServiceItemSelected((service) => {
            return [
                ...service,
                { ...value, parts: 0, labor: 0, subtotal: 0 },
            ]
        });
        setTimeout(() => {
            formRef.setValues({
                [`parts-${serviceItemSelected?.length}`]: null,
                [`labor-${serviceItemSelected?.length}`]: null,
                [`subtotal-${serviceItemSelected?.length}`]: null,
            })
        }, 100);
        const newOptions = optionsSelect.filter((option) => option?.id != value?.id);
        newOptions && setOptionsSelect(OrderData(newOptions, 'name'));
    };



    let title = "";
    if (vehicle) {
        if (maintenanceServiceUnit) {
            title = `${messages['scheduleMaintenanceService_editScheduledServiceFor']} ${vehicle?.label}`;
        } else {
            title = `${messages['scheduleMaintenanceService_scheduleServiceFor']} ${vehicle?.label}`;
        }
    } else if (props.service) {
        if (maintenanceServiceUnit) {
            title = `${messages['scheduleMaintenanceService_editScheduledVehicleFor']} ${props.service?.title}`;
        } else {
            title = `${messages['scheduleMaintenanceService_addVehicle']} ${props.service?.title}`;
        }
    }

    return (
        <Modal
            title={title && title.length > 38 ? title.substring(0, 35) + "..." : title}
            size="small"
            loading={loading || loadingMaintenanceServiceUnit}
            open={open}
            style={{ zIndex: 'auto' }}
            handleClose={handleClose}
            footer={(
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={(e) => formRef.submit()}
                        isDisabled={loading || (loadingPreviousReading && isPastServiceDate(formData.date))}
                    >
                        {maintenanceServiceUnit ? messages['update'] : messages['schedule']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: '18px 35px' }}>
                {
                    errorMessage &&
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 10 }}>
                        <small className="text-danger" style={{ paddingTop: 5 }}>
                            {errorMessage}
                        </small>
                    </div>
                }
                <Form
                    ref={formRef.ref}
                    loading={false}
                    onValidSubmit={(values) => handleSubmit()}
                >
                    {
                        props.service &&
                        <Form.Item
                            name="vehicle"
                            label={messages['scheduleMaintenanceService_vehicle']}
                            rules={[{ required: true, message: 'required_field' }]}
                        >
                            <Select
                                id="vehicle"
                                onChange={(value) => {
                                    setErrorMessage("");
                                    setVehicleType(value?.typeId)
                                    setFormData({ ...formData, vehicle: value });
                                    if (formData.date) {
                                        getReadings(value?.deviceId || value?.id, formData.date);
                                    }
                                }}
                                placeholder={messages['select']}
                                isClearable
                                options={units || []}
                                textField="label"
                                valueField="id"
                                isDisabled={maintenanceServiceUnit || loadingUnitsList}
                                isSearchable
                                createOptions
                            />
                        </Form.Item>
                    }
                    {
                        vehicle &&
                        <Form.Item
                            name="service"
                            label={messages['scheduleMaintenanceService_service']}
                            rules={[{ required: true, message: 'required_field' }]}
                        >
                            <Select
                                id="service"
                                addNewOption={openModalCreateEditMaintenanceService}
                                messageAdd={messages['scheduleMaintenanceService_addNewService']}
                                onChange={(value) => {
                                    if (value?.id) {
                                        setErrorMessage("");
                                        dispatch(maintenanceSMSGetMaintenanceService({ id: value.id }))
                                        setFormData({ ...formData, service: value });
                                    }

                                    if (value?.__isNew__)
                                        dispatch(openModalCreateEditMaintenanceService())

                                }}
                                options={currentServices || []}
                                textField="title"
                                valueField="id"
                                customIcon={() => <IconButton size="large" icon="add" style={{ padding: 5 }} onClick={(e) => {
                                    if (e) e.preventDefault();
                                    dispatch(openModalCreateEditMaintenanceService())
                                }} />}
                                placeholder={messages['select']}
                                maxLength={40}
                                isClearable
                                isSearchable
                                createOptions
                            />
                        </Form.Item>
                    }
                    {
                        maintenanceServiceUnit?.completed &&
                        <Form.Item
                            name="completed"
                            label={messages['scheduleMaintenanceService_dateOfServiceCompletes']}
                            rules={[{ required: true, message: messages['required_field'] }]}
                        >
                            <DatePicker
                                id="completed"
                                showTimePicker
                                calendarPosition="bottom-end"
                                placeholder={messages['scheduleMaintenanceService_selectDate']}
                                format={GetFormatForMoment(user.dateformat)}
                                maxDate={new Date()}
                                onChange={(value) => {
                                    setFormData({ ...formData, completed: value });
                                    setErrorDate(false);
                                }}
                                isDisabled={isDateInputDisabled()}
                            />
                        </Form.Item>
                    }
                    <Form.Item
                        name="date"
                        label={messages['scheduleMaintenanceService_dateOfLastService']}
                        rules={[{ required: true, message: messages['required_field'] }]}
                    >
                        <DatePicker
                            id="date"
                            showTimePicker
                            calendarPosition="bottom-end"
                            placeholder={messages['scheduleMaintenanceService_selectDate']}
                            format={GetFormatForMoment(user.dateformat)}
                            maxDate={new Date()}
                            onChange={(value) => {
                                if (moment(value).isAfter(moment(), 'minutes')) {
                                    setTimeout(() => {
                                        formRef.setValues({ date: null })
                                    }, 200);
                                    return NotificationManager.warning(
                                        messages['scheduleDriverTask_wait'],
                                        messages['scheduleDriverTask_lastService_invalidTime'],
                                        3000,
                                        null,
                                        null,
                                        'success',
                                    );
                                }
                                else {
                                    setErrorDate(false);
                                    setErrorMessage("");
                                    if (isPastServiceDate(value)) {
                                        setFormData({ ...formData, date: value, engineOdometer: "", engineHours: "" });
                                        setTimeout(() => {
                                            formRef.setValues({ engineOdometer: "", engineHours: "" });
                                        }, 100);
                                    } else {
                                        setFormData({ ...formData, date: value });
                                    }
                                }

                                const currentVehicle = vehicle || formData.vehicle;
                                if (currentVehicle) {
                                    getReadings(currentVehicle.deviceId || currentVehicle.id, value);
                                }
                            }}
                            isDisabled={isDateInputDisabled()}
                        />
                    </Form.Item>
                    {
                        (vehicle?.odometerEnable || formData?.vehicle?.odometerEnable) &&
                        <Form.Item
                            name="engineOdometer"
                            label={messages['scheduleMaintenanceService_odometer']}
                            rules={[
                                {
                                    required: validateOdometer,
                                    message: messages['required_field']
                                },
                                {
                                    min: validateOdometer ? 1 : 0,
                                    message: `${messages['min']}: 1`
                                },
                                {
                                    max: 1000000000,
                                    message: `${messages['max']}: 1000000000`
                                }
                            ]}
                        >
                            <InputNumeric
                                id="engineOdometer"
                                type="number"
                                onlyPositive
                                placeholder={messages['scheduleMaintenanceService_odometer']}
                                onChange={(value) => {
                                    const odometerMiles = user.isKph ? convertToMI(value) : value;
                                    let next = calculateNextOdometer(formData.service, odometerMiles);
                                    let newFormData = { engineOdometer: odometerMiles };

                                    if (formData.service.miles) {
                                        let { intervalTypes } = formData;
                                        let newIntervalTypes = intervalTypes.filter(intervalType => intervalType.intervalType != messages['miles']);
                                        newIntervalTypes.push(next);
                                        newFormData.intervalTypes = newIntervalTypes;
                                        newFormData.nextServiceOdometer = next.next;
                                    }

                                    setFormData((prev) => ({ ...prev, ...newFormData }));
                                }}
                                isDisabled={!formData.date || loadingPreviousReading || vehicleType === 31}
                            />
                        </Form.Item>
                    }
                    {
                        vehicle?.hoursEnable &&
                        <Form.Item
                            name="engineHours"
                            label={messages['scheduleMaintenanceService_engineHours']}
                            rules={[
                                {
                                    required: validateEngineHours,
                                    message: messages['required_field']
                                },
                                {
                                    min: validateOdometer ? 1 : 0,
                                    message: `${messages['min']}: 1`
                                },
                                {
                                    max: 1000000000,
                                    message: `${messages['max']}: 1000000000`
                                }
                            ]}
                        >
                            <InputNumeric
                                id="engineHours"
                                type="number"
                                onlyPositive
                                placeholder={messages['scheduleMaintenanceService_engineHours']}
                                onChange={(value) => {
                                    let next = calculateNextEngineHours(formData.service, value);
                                    let newFormData = { engineHours: value };
                                    if (formData.service.engineHours) {
                                        let { intervalTypes } = formData;
                                        let newIntervalTypes = intervalTypes.filter(intervalType => intervalType.intervalType != messages['engineHours']);
                                        newIntervalTypes.push(next);
                                        newFormData.intervalTypes = newIntervalTypes;
                                        newFormData.nextServiceEngineHours = next.next
                                    }
                                    setFormData({ ...formData, ...newFormData });
                                }}
                                maxLength={10}
                                isDisabled={!formData?.date || loadingPreviousReading || vehicleType === 31}
                            />
                        </Form.Item>
                    }
                    <Form.Item
                        name="options"
                        label={messages['completeMaintenanceService_add_service_items']}
                    >
                        <div className="test-options">
                            <Select
                                addNewOption={addNewOption}
                                messageAdd={messages['completeMaintenanceService_add_new_service_item']}
                                onChange={(data) => {
                                    let payload = data
                                    if (payload?.label) {
                                        payload.name = payload?.label
                                    }

                                    if (data?.id)
                                        onChangeSelectedItems(payload)
                                }}
                                id="options"
                                options={optionsSelect}
                                textField="name"
                                valueField="id"
                                customIcon={() => <IconButton size="large" icon="add" style={{ padding: 5 }} />}
                                placeholder={messages['select']}
                                maxLength={40}
                                createOptions
                                isClearable
                                isSearchable
                            />
                        </div>

                    </Form.Item>
                    {serviceItemSelected && serviceItemSelected.map((item, key) => renderItem(item, key))}
                    <Form.Item
                        name="totalCost"
                        label={messages['completeMaintenanceService_total_cost']}
                    >
                        <InputNumeric
                            id="totalCost"
                            isDisabled={true}
                            placeholder="$0.00"
                            type="currency"
                        />
                    </Form.Item>

                    <Form.Item
                        name="attachments"
                        label={messages['updateService_attachmentsInputLabel']}
                    >
                        <FileUpload
                            id="attachments"
                            placeholder={messages['updateService_attachmentsInputPlaceholder']}
                            types="image/*,.txt,.doc,.docx,.pdf,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            maxSize={4}
                            maxSizeMessage={`${messages['max']}: 4MB`}
                            helpText={messages['attachmentsFilesAllowed']}
                            uploadAttachment={(data) => { dispatch(uploadAttachment(data)) }}
                            uploadedAttachment={uploadedAttachment}
                            loadingUploadFile={loadingUploadFile}
                            onChange={(value) => setFormData({ ...formData, attachments: value })}
                        />
                    </Form.Item>
                    <Form.Item
                        name="alerts"
                        label={messages['updateService_subscribers']}
                    >
                        <SelectMenu
                            id="alerts"
                            options={contacts || []}
                            loading={loadingContacts}
                            onChange={(value) => setFormData({ ...formData, alerts: value })}
                            textField="title"
                            valueField="contactId"
                            placeholder={messages["scheduleVehicleService_alert_placeholder"]}
                            extraOptions={ALERT_TYPES || []}
                            extraOptionstextField="name"
                            extraOptionsvalueField="id"
                            extraOptionsRequiredMessage={messages["scheduleVehicleService_alert_error_message"]}
                            buttonLabel={messages["scheduleVehicleService_alert_button_label"]}
                            type="multi-checkbox"
                        />
                    </Form.Item>
                    <Form.Item
                        name="notes"
                        label={messages['scheduleMaintenanceService_notes']}
                    >
                        <TextArea
                            id="notes"
                            placeholder={messages['scheduleMaintenanceService_notes']}
                            type="textarea"
                            maxLength={2000}
                            onChange={(value) => setFormData({ ...formData, notes: value })}
                        />
                    </Form.Item>
                </Form>
                {
                    formData?.service ?
                        <div>
                            <div className="text-muted" style={{ marginBottom: 10, fontSize: 16 }}>{messages['scheduleMaintenanceService_serviceSettings']}</div>
                            <div style={{ marginBottom: 18 }}>
                                {
                                    formData?.intervalTypes.length > 0
                                    &&
                                    <div>
                                        <div className="gtc-rc-textarea-label"><label style={{ fontSize: 12, fontWeight: 410 }}>{messages['scheduleMaintenanceService_intervalTypes']}</label></div>
                                        <div style={{ width: '100%', marginTop: 10 }}>
                                            {
                                                formData.intervalTypes.map((intervalType, index) => {
                                                    const { interval, reminder, pastDue, next } = intervalType;
                                                    let label = `${interval ? messages["due_every"] + " " + interval : ""} ${intervalType.intervalType}, ${(reminder ? messages['reminder_at'] + ' ' + reminder + ", " : '')} ${(pastDue ? messages['pastDue_at'] + " " + pastDue + ',' : '')} ${messages['next_in']} ${next} ${intervalType && intervalType.intervalType != messages['days'] ? intervalType.intervalType : ''}`;
                                                    return (
                                                        <div key={index} style={{ width: '100%' }}>
                                                            <Chip label={label} />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                            {
                                maintenanceService?.notes &&
                                <TextArea
                                    id="notes"
                                    label={messages['scheduleMaintenanceService_servicesNotes']}
                                    placeholder={messages['scheduleMaintenanceService_notes']}
                                    type="textarea"
                                    value={maintenanceService?.notes}
                                    onChange={(value) => { }}
                                    isDisabled
                                />
                            }
                            {
                                maintenanceService?.files
                                && maintenanceService?.files.length > 0 &&
                                <div className="schedule-maintenace-attachments-container" style={{ marginBottom: 18 }}>
                                    <FileUpload
                                        id="attachments"
                                        label={messages['scheduleMaintenanceService_servicesAttachment']}
                                        value={maintenanceService?.files}
                                        placeholder={messages['updateService_attachmentsInputPlaceholder']}
                                        maxSize={4}
                                        maxSizeMessage={`${messages['max']}: 4MB`}
                                        helpText={messages['attachmentsFilesAllowed']}
                                        uploadAttachment={(data) => { dispatch(uploadAttachment(data)) }}
                                        uploadedAttachment={uploadedAttachment}
                                        loadingUploadFile={false}
                                        onChange={(value) => { }}
                                        isDisabled
                                    />
                                </div>
                            }
                        </div>
                        : <></>
                }
            </div>
            <NotificationContainer />
        </Modal>
    )
}

export default ScheduleMaintenanceService
